import { Files } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgFileDouble = mkIcon(Files);
